import React, { Fragment, FunctionComponent } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import {
  Wrapper,
  Title,
  Line,
  Label,
  Value,
  Percentage,
  TriangleOne,
  TriangleTwo,
  Legend,
  LegendLine,
  LegendLineDot,
} from "./styles/funnel-large-styles";

interface IFunnelItemProps {
  id?: number;
  color?: string;
  label?: string;
  value?: number;
  percentage?: {
    tooltip?: string;
    value?: number;
  };
}

interface IFunnelLargeProps {
  data: Array<IFunnelItemProps>;
  showLegend?: boolean;
  title?: boolean;
  bordered?: boolean;
  tooltips?: boolean;
  dataTestId?: string;
}

const FunnelLarge: FunctionComponent<IFunnelLargeProps> = ({
  data,
  showLegend,
  title,
  bordered,
  tooltips,
  dataTestId,
}) => (
  <div>
    {tooltips && (
      <Fragment>
        <ReactTooltip
          place="top"
          type="dark"
          effect="float"
          aria-haspopup="true"
          id="funnel line tooltip"
        />
        <ReactTooltip
          place="left"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="percentage tooltip"
        />
      </Fragment>
    )}
    <Wrapper data-test-id={dataTestId}>
      <TriangleOne />
      <TriangleTwo />
      {title && <Title>{title}</Title>}
      {data.map((item) => (
        <Line
          bordered={bordered}
          fillColor={item.color}
          key={item.id}
          data-tip={`${item.label}: ${item.value}`}
          data-for="funnel line tooltip"
        >
          <Label
            className={`animated fadeIn delay-${item.id}`}
            data-test-id="funnel-label"
          >
            {item.label}
          </Label>
          <Value
            className={`animated fadeIn delay-${item.id}`}
            data-test-id="funnel-value"
          >
            {item.value}
          </Value>
        </Line>
      ))}
      {data.map(
        (item) =>
          item.percentage && (
            <Percentage
              key={item.id}
              itemId={item.id}
              data-tip={item.percentage.tooltip}
              data-for="percentage tooltip"
              className={`animated fadeIn delay-${item.id}`}
            >
              {`${item.percentage.value}%`}
            </Percentage>
          )
      )}
    </Wrapper>
    {showLegend && (
      <Legend>
        {data.map((item) => (
          <LegendLine key={item.label}>
            <LegendLineDot fillColor={item.color} />
            {item.label}
          </LegendLine>
        ))}
      </Legend>
    )}
  </div>
);

FunnelLarge.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      color: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.number,
      percentage: PropTypes.shape({
        tooltip: PropTypes.string,
        value: PropTypes.number,
      }),
    })
  ).isRequired,
  showLegend: PropTypes.bool,
  title: PropTypes.bool,
  bordered: PropTypes.bool,
  tooltips: PropTypes.bool,
  dataTestId: PropTypes.string,
};

FunnelLarge.defaultProps = {
  showLegend: null,
  title: null,
  bordered: null,
  tooltips: null,
  dataTestId: null,
};

export default FunnelLarge;
